import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios-instance";

export const fetchIndividualAssessments = createAsyncThunk(
    "individualAssessments/fetchIndividualAssessments",
    async () => {
        try {
            const response = await axiosInstance({
                method: "get",
                url: "/individual-assessments"
            });
            return response.data.data;
            
        } catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    }
);
